import styled from "styled-components";
import SvgBusiness from "./worksSvg";

const StyledSection = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const StyledGridRow = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
`;
const StyledWrapper = styled.div`
  line-height: 1.5;
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  align-items: center;
  padding: 1rem 2rem;
  margin-bottom: 2rem;
  h2 {
    font-size: 3rem;
    line-height: 4.2rem;
    font-weight: 700;
    width: 100%;
    text-align: center;
    margin-bottom: 0;
    @media screen and (max-width: 1280px) {
      margin: 2rem 0 0 0;
    }
    @media screen and (max-width: 992px) {
      line-height: 2.8rem;
      font-size: 2rem;
    }
    @media screen and (max-width: 768px) {
      text-align: left;
    }
  }
  p {
    text-align: center;
    font-size: 1.2rem;
    line-height: 2rem;
    margin-bottom: 4rem;
    @media screen and (max-width: 768px) {
      text-align: left;
      margin-bottom: 1rem;
    }
  }
  @media screen and (max-width: 768px) {
    margin-bottom: 0;
  }
`;

const gridData = [
  {
    icon: "one",
    title: "We can't see your data.",
    text: `And we don't want to. All processes
performed by Redact
are handled privately between you
and the platform.`,
  },
  {
    icon: "two",
    title: "Your data. Your rules.",
    text: `We believe that privacy is a universal right. We cannot see, store, or interact with your data or login information. All logins are securely handled directly by the platforms.`,
  },

  {
    icon: "three",
    title: "Simple business model.",
    text: `You don't have to guess how we make money. We will never sell or share your data.`,
  },
  {
    icon: "four",
    title: "Let us do the heavy lifting",
    text: `Redact actively stays up to date with changes on social media platforms and data brokers, ensuring you don't have to do anything to keep your data secure.
`,
  },
  {
    icon: "five",
    title: "No servers. No middlemen.",
    text: `Redact runs locally on your device. All your data stays on your device and no logs are collected by the Redact application. You may opt into a local-only log of your data.`,
  },
  {
    icon: "six",
    title: "4 years of operation, and a pro team.",
    text: `Our team is comprised of privacy experts from around the world, passionate about user privacy and rights.`,
  },
];

const StyledBlock = styled.div`
  flex: 1 1 340px;
  display: flex;
  gap: 1rem;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 2rem;
  svg {
    width: 60px;
    align-self: flex-start;
    height: auto;
    flex: 0 0 60px;
  }
  h3 {
    margin-top: 0;
  }
  @media screen and (max-width: 768px) {
    text-align: center !important;
    display: flex;
    flex-direction: column;
    svg {
      align-self: center !important;
    }
  }
`;
const StyledGradientSpan = styled.span`
  background: linear-gradient(270deg, #7551cb 3.49%, #5172c8 92.38%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
const StyledTitleH2 = styled.h2`
  margin-bottom: 5rem !important;
  @media screen and (max-width: 768px) {
    text-align: center !important;
  }
`;
export const Grid = () => {
  return (
    <StyledSection>
      <StyledWrapper>
        <StyledTitleH2>
          <StyledGradientSpan>Built for privacy</StyledGradientSpan> from the ground up.
        </StyledTitleH2>
        <StyledGridRow>
          {gridData.map((obj) => {
            return (
              <StyledBlock key={obj.text}>
                <SvgBusiness name={obj.icon} />
                <div>
                  <h3>{obj.title}</h3>
                  <label>{obj.text}</label>
                </div>
              </StyledBlock>
            );
          })}
        </StyledGridRow>
      </StyledWrapper>
    </StyledSection>
  );
};

export default Grid;
